import { api } from "./base-config";
import { TenantData } from "model/tenant-data.model";

/** ---- API CALLS ---- */
export const findTenantData = (): Promise<TenantData> => {
  return api
    .get(`/resources/secured/rs/tenant/data`)
    .then(() => new TenantData());
};
